/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon16Regular = forwardRef('DataStructureGraphIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4a3 3 0 0 1 3-3h5a3 3 0 1 1 0 6h-.765l1.333 2H12a3 3 0 1 1 0 6H7a3 3 0 1 1 0-6h.765L6.432 7H4a3 3 0 0 1-3-3Zm3-1.5a1.5 1.5 0 1 0 0 3h5a1.5 1.5 0 1 0 0-3H4Zm3 8a1.5 1.5 0 0 0 0 3h5a1.5 1.5 0 0 0 0-3H7Z" })));
});
